export default __webpack_public_path__ + "static/media/motor.e33a0d8b.png";